import { Box } from '@mui/material';
import { SparkFormImageUploader } from 'sharedComponents/SparkForm';
import MemorySectionHeader from '../MemorySectionHeader';

type MemoryThumbnailProps = {
  onUpdateThumbnail?: (imageURL: string) => void;
};

function MemoryThumbnail({ onUpdateThumbnail }: MemoryThumbnailProps) {
  return (
    <Box>
      <MemorySectionHeader headerText='Thumbnail' />
      <SparkFormImageUploader
        name='imageURL'
        containerName='app-assets'
        onUpload={onUpdateThumbnail}
      />
    </Box>
  );
}

export default MemoryThumbnail;
